<template>
  <div class="container">
    <ClinicDetail v-if="clinic && clinic.data" :clinic="clinic.data"/>
  </div>
</template>

<script lang="ts" setup>
import type {TClinicDetail, TClinicDetailRaw} from '~/types/clinic'
import {omitClinicPhoneDeep} from '~/utils/omitClinicPhone'
const headers = useRequestHeaders()
const userAgent = headers['user-agent']

const route = useRoute();
const {trackPageView} = usePageView();

onMounted(() => {
  trackPageView('clinics_catalog', `${route.params.city}/${route.params.clinic}`);
});

const {data: clinic, error} = await useFetch<{ data?: TClinicDetailRaw }>(`/public/clinics/${route.params.city}/${route.params.clinic}`, {
  baseURL: useApiBaseUrl(),
  headers: {
    Accept: 'application/json',
    'User-Agent': userAgent || '',
  },
  transform: (response) => ({
    ...response,
    data: response.data ? omitClinicPhoneDeep(response.data) : response.data,
  }),
})
if (error.value) {
  // Карточку слили с дублем: её слаг сохранён у мягко удалённой строки, и бэк отдаёт
  // адрес выжившей — старый адрес обязан отвечать 301, а не 404.
  const movedTo = (error.value.data as {moved_to?: string | null} | undefined)?.moved_to;
  if (movedTo) {
    await navigateTo(movedTo, {redirectCode: 301});
  } else if (error.value.statusCode === 404) {
    throw createError({ statusCode: 404, statusMessage: 'Клиника не найдена', fatal: true });
  } else {
    throw createError({ statusCode: error.value.statusCode || 500, statusMessage: 'Не удалось загрузить клинику', fatal: true });
  }
}
definePageMeta({
  validate: async (route) => {
    return typeof route.params.city === 'string' && /^[a-z-_]+$/.test(route.params.city) && typeof route.params.clinic === 'string' && /^[a-z-0-9_]+$/.test(route.params.clinic)
  }
});
</script>

<style lang="scss" scoped>

</style>